// extracted by mini-css-extract-plugin
export default {"mapChart":"PageVisits_mapChart__uCK56","map":"PageVisits_map__HZJSy","stats":"PageVisits_stats__Q0O5O"};